import { Link } from "@inertiajs/react";
import styled, { css } from "styled-components";

const cardStyles = css`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  border-radius: 12px;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  padding: 24px;
  transition: all 0.3s ease;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
    border-color: rgba(201, 169, 97, 0.5);
    background-color: rgba(201, 169, 97, 0.05);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  }
`;

const CardLink = styled(Link)`
  ${cardStyles}
`;

// Full-page navigation for links that leave this Inertia stack (e.g. the
// marketing /insights site, served by a different entrypoint).
const CardAnchor = styled.a`
  ${cardStyles}
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 8px;
  background-color: rgba(201, 169, 97, 0.1);
  transition: all 0.3s ease;

  svg {
    width: 32px;
    height: 32px;
    color: #c9a961;
  }
`;

const CardContent = styled.div`
  text-align: center;
`;

const CardTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

const CardDescription = styled.p`
  margin-top: 4px;
  font-size: 13px;
  color: #4b5563;
  margin: 0;
`;

export const ServiceCard = ({
  title,
  icon: Icon,
  href,
  description,
  external = false,
}) => {
  const Inner = (
    <>
      <IconWrapper>
        <Icon />
      </IconWrapper>
      <CardContent>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardContent>
    </>
  );

  if (external) {
    return <CardAnchor href={href}>{Inner}</CardAnchor>;
  }

  return <CardLink href={href}>{Inner}</CardLink>;
};
